import Image from "src/mobile/ui/common/Image";

export default Image;
